export default __webpack_public_path__ + "media/images/home/living_interior_design-5aaaebf03908d8c5b06e87cc6b42f4ed.png";